<template>
  <f7-page>
    <div class="page-content">
      <div class="block text-align-center">
        <h1>404</h1>
        <p>抱歉，您访问的页面不存在或已被移除</p>
        <p>The page you are looking for does not exist. Please check the URL or return to the homepage.</p>
      </div>
    </div>
  </f7-page>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {}
}
</script>

<style scoped>
.block {
  margin-top: 60px;
}
h1 {
  font-size: 72px;
  color: #666;
  margin-bottom: 20px;
}
</style> 